import { ReturnLogsReadable } from '@crm/api'
import { DayLabel, Text } from '@shared/components'
import { getFullName } from '@shared/utils'
import { Card, Col, Flex, Row } from 'antd'

import { useStyles } from './styles'

type Props = {
  comment: ReturnLogsReadable
  isCommentOwner?: boolean
}

export const KanbanCommentsItem = ({ comment, isCommentOwner }: Props) => {
  const { styles } = useStyles({ isCommentOwner })

  const justifyPosition = isCommentOwner ? 'end' : 'start'

  return (
    <Flex vertical gap={8} className="mb-10">
      <Row gutter={12} justify={justifyPosition}>
        <Col span={18}>
          <Card variant="borderless" className={styles.commentItem}>
            <Flex vertical gap={20}>
              <Text size={16}>{comment?.description}</Text>
            </Flex>
          </Card>
        </Col>
      </Row>

      <DayLabel
        justify={justifyPosition}
        date={comment?.created_at}
        name={getFullName(comment?.created_by)}
      />
    </Flex>
  )
}
